<template>
    <div ref="chartRef" class="chart">

    </div>
</template>

<script>
    import * as echarts from "echarts"
    export default {
        name: "Chart",
        data(){
            return{
                chart:null
            }
        },
        props:{
            rateList:{
                type:Array,
                required:true
            }
        },
        mounted(){

            this.initChart();
            this.updateChart();
             },
        methods:{
            initChart(){
                this.chart=echarts.init(this.$refs.chartRef);
            },
            updateChart(){
                const option = {
                    title:{
                        text:this.$t('details.qryear'),
                        textStyle:{
                            color:'#ff9900'
                        },
                        left: "5%"
                    },
                    xAxis: {
                        type: 'category',
                        data:[],
                        boundaryGap:false
                    },
                    yAxis: {
                        type: 'value',
                        name:this.$t('details.lilu'),
                        axisLabel: {
                            formatter: '{value} %',
                            align: 'center',
                            // ...
                        },
                        //  scale:true   //是否支持缩放
                    },
                    tooltip:{
                        show:true,
                        trigger:'axis' //触发类型
                    },
                    series: [
                        {
                            data: this.rateList,
                            type: 'line',
                            markPoint:{
                                data:[
                                    {
                                        type:'max'
                                    },
                                    {
                                        type:'min'
                                    }
                                ]
                            },
                            markLine:{
                                data:[
                                    {
                                        type:'average'   //平均线
                                    }
                                ]
                            },
                            //    smooth:true,  //是否开启平滑折线
                            lineStyle:{
                                color:'red'     //线颜色
                            },
                            //areaStyle:{}  //拆线填充
                        }
                    ]
                };
                let base = new Date().getTime();
                let oneDay = 24 * 3600 * 1000;
                let date = [];
                let data = [Math.random() * 300];
                let time = new Date(base);
                date.push([time.getMonth()+1,time.getDate()].join('/'));
                for(let i = 1;i < 7;i++){
                    let now = new Date(base -= oneDay);
                    date.push([now.getMonth()+1,now.getDate()].join('/'));
                    data.push(Math.round((Math.random() - 0.5) * 20 + data[i-1]));
                }
                let newdate = date.reverse();
                option.xAxis.data=newdate;

                this.chart.setOption(option);
            }
        },
        watch:{
            deep: true,
            rateList:{
                handler(val,oval){
                    this.chart.setOption({series:[{data:val}]});
                }
            }

        }
    }
</script>

<style scoped lang="scss">
 .chart{
     height: 260px;
     background: white;
     padding-top: 20px;
 }
</style>
